// extracted by mini-css-extract-plugin
export default {"settings":"Settings_settings__q0cUJ","dark":"Settings_dark__ApJjT","themes":"Settings_themes__7zemQ","permission":"Settings_permission__w1Tnr"};